import React from 'react';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { TitleBar } from 'components/Layouts/TitleBar';
import { tenantInfoState } from 'modules/application/atoms';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { ReactComponent as OrderConfirmedIcon } from 'assets/icons/undraw_order_confirmed.svg';
import { commonMessages } from 'utils/commonMessages';
import { Link, useLocation } from 'react-router-dom';

interface LocationState {
  email: string
}

export const ServiceCallSubmissionConfirmationPage = () => {
  const location = useLocation();
  const { formatMessage } = useIntl();

  const tenantInfo = useRecoilValue(tenantInfoState);
  const state = location.state as LocationState;

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'ServiceCallSubmissionConfirmationPage.Title', defaultMessage: 'Service call Submission Confirmation' })} - {tenantInfo.name}</title>
        <meta name="description" content={formatMessage({ id: 'ServiceCallSubmissionConfirmationPage.Description', defaultMessage: 'Service call Submission Confirmation' })} />
      </Helmet>
      <TitleBar title={formatMessage({ id: 'CreateServiceCallPage.Title', defaultMessage: 'Service Call' })}/>
      <Container maxWidth='xl'>
        <Paper elevation={0} sx={{mt:4, p: 3}}>
          <Stack direction='row' justifyContent='space-between' flexWrap='wrap-reverse'>
            <Stack gap={4}>
              <Typography variant='h3'>{formatMessage({ id: 'ServiceCallSubmissionConfirmationPage.Confirmation', defaultMessage: 'Your request has been submitted successfully!' })}</Typography>
              <Stack direction='row' gap={1} rowGap={0} flexWrap='wrap'>
                <Typography>{formatMessage({ id: 'ServiceCallSubmissionConfirmationPage.Instruction', defaultMessage: 'A confirmation email will be sent to you shortly at' })}</Typography>
                <Typography fontWeight={500}>{state.email}</Typography>
              </Stack>
              <Stack direction='row' gap={2}>
                <Button component={Link} to='/' variant='contained' color='primary'>{formatMessage(commonMessages.back)}</Button>
              </Stack>
            </Stack>
            <Box width={220}>
              <OrderConfirmedIcon />
            </Box>
          </Stack>
        </Paper>
      </Container>
    </>
  );
};